import { module } from 'modujs';
import { html } from '../utils/environment'

export default class extends module {
    constructor(m) {
        super(m);

        this.events = {
            click: 'trigger'
        }
    }

    init() {

    }

    trigger() {
        if(html.classList.contains('has-menu-lang-open')) {
            this.call('close','MenuLang');
        } else {
            this.call('open','MenuLang');
        }
    }
}
